import React from "react";

const features = [
  {
    title: "Fire-Rated Doors",
    desc: "Certified hinges for safety-critical applications",
    img: "fire.svg" // Fire emoji (SVG)
  },
  {
    title: "Quality",
    desc: "Pure and complete Stainless Steel hinges",
    img: "quality.svg" // Shield/quality emoji (SVG)
  },
  {
    title: "High-Security Applications",
    desc: "Tamper-resistant hinges for sensitive facilities",
    img: "lock.svg" // Lock emoji (SVG)
  },
  {
    title: "Extreme Weather Conditions",
    desc: "Weather-resistant solutions for harsh environments",
    img: "cloud.svg" // Cloud with lightning (SVG)
  },
  {
    title: "Heavy-Duty Doors",
    desc: "High-weight capacity hinges for large doors",
    img: "hammer.svg" // Hammer emoji (SVG)
  }
];

const ProductFeature = () => {
  return (
    <div className="w-full py-10  pb-0 px-4 md:px-10 bg-white flex justify-center items-center md:h-[80vh]">
      <section className="max-w-7xl mx-auto flex flex-col-reverse mt-[14%] md:mt-[10%] lg:flex-row items-center gap-10">
        {/* Left Content: Features List */}
        <div className="w-full lg:w-1/2 flex flex-col gap-8">
          {features.map((feature, idx) => (
            <div key={idx} className="flex items-start gap-4">
              <div className="text-blue-600 mt-1">
                {/* <i className="fa-solid fa-user text-2xl"></i> */}
                <img src={feature.img} className="w-[30px]" alt="" />
              </div>
              <div>
                <h4 className="text-xl md:text-2xl font-semibold mb-2">
                  {feature.title}
                </h4>
                <p className="text-gray-600 text-base md:text-lg">
                  {feature.desc}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Right Image */}
        <div className="w-full lg:w-[30%] flex justify-center">
          <img
            src="fire_rated_doors.svg"
            alt="Product"
            className="w-full max-w-md md:max-w-lg lg:max-w-xl h-auto object-cover rounded"
          />
        </div>
      </section>
    </div>
  );
};

export default ProductFeature;
